'use client'

import { useEffect, useState } from 'react'
import { useQuery } from '@tanstack/react-query'
import { tilesQueryOptions } from '@/service/queries/use-tile-query'
import { useFilterStore } from '@/shared/store/filter.store'
import { useTileStore } from '@/shared/store/tile.store'

function subscribeIdle(onIdle: () => void) {
  if ('requestIdleCallback' in window) {
    const id = window.requestIdleCallback(() => onIdle(), { timeout: 2000 })
    return () => window.cancelIdleCallback(id)
  }
  const t = setTimeout(onIdle, 1)
  return () => clearTimeout(t)
}


export function TilesStoreSync() {
  const [tilesQueryEnabled, setTilesQueryEnabled] = useState(false)

  useEffect(() => subscribeIdle(() => setTilesQueryEnabled(true)), [])

  const { data } = useQuery({
    ...tilesQueryOptions,
    enabled: tilesQueryEnabled,
  })

  const setTiles = useTileStore((s) => s.setTiles)
  const setFilteredTiles = useFilterStore((s) => s.setFilteredTiles)

  useEffect(() => {
    const tiles = data ?? []
    setTiles(tiles)
    setFilteredTiles(tiles)
  }, [data, setTiles, setFilteredTiles])

  // return
  return null
}
